module.exports = __webpack_public_path__ + "static/img/classVideo5.3f2014d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/classVideo5.png
// module id = yH1m
// module chunks = 1